
const orderStatus = {
  0: "printing",
  1: "pending",
  2: "canceled",
  3: "paid",
  4: "Quality Checks",
  5: "Cleanup",
  6: "Delivery Scheduled",
  7: "With Courier",
  8: "Delivered",
  9: "pause",
  10: "error",
  11: "Setup",
  12: "Setup Done"
}
const initialSliceStatus = {
  0: "notReady",
  1: "readyForSlicing",
  2: "slicing",
  3: "sliced",
  4: "error"
}
module.exports = {
  orderStatus,
  initialSliceStatus
};
